module.exports = __webpack_public_path__ + "img/c16f387.png";